/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Auction_Date_Tour2Inputs */

const cs_sreality_attr_auction_date_tour2 = /** @type {(inputs: Sreality_Attr_Auction_Date_Tour2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termín 2. prohlídky`)
};

const en_sreality_attr_auction_date_tour2 = /** @type {(inputs: Sreality_Attr_Auction_Date_Tour2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2nd Viewing Date`)
};

/**
* | output |
* | --- |
* | "2nd Viewing Date" |
*
* @param {Sreality_Attr_Auction_Date_Tour2Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_auction_date_tour2 = /** @type {((inputs?: Sreality_Attr_Auction_Date_Tour2Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Auction_Date_Tour2Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_auction_date_tour2(inputs)
	return cs_sreality_attr_auction_date_tour2(inputs)
});